import { useSelector } from 'react-redux'
import { Alert, Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import ConfirmFormFooter from '../../Components/antd/Forms/ConfirmFormFooter'

const ConfirmSchoolModal = ({ visible = false, onLogin, onNewSchool }) => {
  const t = useSelector(selectTranslate)

  return (
    <Modal
      title={t('school_portal.requester.confirm_school.title')}
      visible={visible}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={(
        <ConfirmFormFooter
          confirmTitle={t('school_portal.requester.confirm_school.new_school')}
          cancelTitle={t('school_portal.requester.confirm_school.login')}
          confirmClassName='logo-colored-button orange orange-ghost-hover'
          cancelClassName='logo-colored-button blue-ghost blue-hover'
          onCancel={onLogin}
          onConfirm={onNewSchool}
        />
      )}
    >
      <Alert
        description={t('school_portal.requester.confirm_school.already_linked')}
        type='warning'
        showIcon
        icon={<FontAwesomeIcon icon={faTriangleExclamation} />}
      />
      <br />
      <span>{t('school_portal.requester.confirm_school.question')}</span>
    </Modal>
  )
}

export default ConfirmSchoolModal
